import React from 'react';

import TitleSection from './title-section';
import HeroBanner from './hero-banner';

import './category-landing-page.less';


const CLP = () => {
    return <div className={'category-landing-page'}>
        <HeroBanner />
        <TitleSection />
    </div>;
}

export default CLP;